import { useEffect } from "react";

const PaymentModal = ({ show, onClose }) => {
  
    useEffect(() => {
    if (show) {
      const modal = new window.bootstrap.Modal( document.getElementById("successModal") );
      modal.show();
      const handleHidden = () => onClose && onClose();
      document.getElementById("successModal").addEventListener("hidden.bs.modal", handleHidden);
      return () => {
        document.getElementById("successModal").removeEventListener("hidden.bs.modal", handleHidden);
      };
    }
  }, [show, onClose]);

  return (
    <div className="modal fade" id="successModal" tabIndex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content text-center p-4">
          <div className="modal-body">
            <i className="fa-solid fa-circle-check fa-2x text-success mb-3"></i>
            <h5 className="fw-bold">You ordered successfully</h5>
            <p className="text-muted mb-3" style={{ fontSize: "14px" }}>
              Your order is confirmed and will be delivered within 20 minutes.
            </p>
            <button
              type="button"
              className="btn btn-link text-dark fw-bold text-decoration-none"
              data-bs-dismiss="modal"
            >
              KEEP BROWSING
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
